import React, { createContext, useContext, ReactNode } from "react";
import { Tab } from "@/store/navigation/types";
import { To } from "react-router";

export type RouterLocationState = {
  highlightText?: string;
  autoFocus?: boolean;
  autoFocusPosition?: "start" | "end";
  autoStartVoice?:
    | boolean
    | {
        windowId: string;
        windowTitle?: string;
        windowUrl?: string;
        platform: string;
        showOnboardingTooltip?: boolean;
      };
  retriggerSearch?: boolean;
  historyVersion?: number;
  [key: string]: unknown;
};

interface TabContextType {
  activeTab: Tab;
  activeTabPath: To;
  routerLocationState?: RouterLocationState;
}

const TabContext = createContext<TabContextType | null>(null);

export const useMaybeTabContext = () => {
  return useContext(TabContext);
};

export const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error("useTabContext must be used within a TabProvider");
  }
  return context;
};

interface TabProviderProps {
  activeTab: Tab;
  activeTabPath: To;
  routerLocationState?: RouterLocationState;
  children: ReactNode;
}

export const TabProvider: React.FC<TabProviderProps> = ({
  activeTab,
  activeTabPath,
  routerLocationState,
  children,
}) => {
  return (
    <TabContext.Provider value={{ activeTab, activeTabPath, routerLocationState }}>
      {children}
    </TabContext.Provider>
  );
};
